<template>
  <div
    :id="id"
    class="board"
    @dragover.prevent
    @dragenter.prevent
    @drop.prevent="drop"
    :selection="selection"
    :childs="childs"
    :limit="limit"
    :class="classObject">

    <slot />
  </div>
</template>

<script>
export default {
  props: ['id', 'selection', 'limit', 'childs'],
  data() {
    return {
      classObject: {
        'grid-x4': !this.limit || this.limit > 6,
      }
    }
  },
  methods: {
    drop(e) {
      if (this.childs < this.limit || !this.limit) {
        const card_id = e.dataTransfer.getData('card_id');
        const card = document.getElementById(card_id);
        this.$store.state.isSelected = this.selection;

        if (e.target !== document.getElementById(card_id).parentNode) {
          this.$emit('card-dropped', this.childs)
        }

        e.target.appendChild(card);
      } else {
        return false;
      }

      e.target.classList.remove('dragging-over');
    },
  }
}

</script>

<style scoped>
  .board {
    background-color: #efefef;
    min-height: 100px;
    display: grid;
    grid-template-rows: 1fr 1fr 1fr;
    grid-gap: 10px;
    padding: 0.5rem;
  }

  .grid-x4 {
    grid-template-columns: 1fr 1fr 1fr;
  }
  @media (min-width: 576px) {
    .grid-x4 {
      grid-template-columns: 1fr 1fr 1fr 1fr;
    }
  }

  
</style>
